export class Base {
    element;
    preprocessor;
    validator;

    constructor(element) {
        if (this.constructor === Base)
            throw new Error("Can't instantiate abstract class");

        if (element.tagName !== 'INPUT')
            throw new Error('Invalid element tag name. Must be \'input\'');

        this.element = element;
    }

    isValid(options) {
        let value = this.element.value;

        if (this.preprocessor !== undefined && typeof this.preprocessor === "function")
            value = this.preprocessor(value);

        return this.validator(value, [...options])
    }
}
